import * as React from 'react';
import { useEffect } from 'react';
import LeadDropdownFilter from '@/components/Filters/LeadDropdownFilter';
import { F } from '@/utils/intl';
import { FlagFilled } from '@ant-design/icons';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'umi';
import * as PreferencesSelectors from '@/selectors/preferencesSelectors';
import isEmpty from 'lodash/isEmpty';


export const LeadPriorityPresentation = ({priority}) => {
  return (
    <Space size={6}>
      {priority.icon || <FlagFilled style={{ color: priority.color }}/>}
      <span>{priority.name || priority.label}</span>
    </Space>
  )
}

const LeadPriorityDropdownFilters = ({ onSelectionChange, readonly, ...props }) => {

  const priorities = useSelector(PreferencesSelectors.selectPriorityList)
  const dispatch = useDispatch()
  const LEAD_PRIORITY = (priorities || []).map((priority) => ({
    icon: <FlagFilled style={{ color: priority.color }} />,
    id: priority.value,
    name: priority.label,
  }))
  ;
  useEffect(() => {
    if (isEmpty(priorities)){
      dispatch({
        type: 'preferences/fetch'
      })
    }
  }, []);



  const optionRender = (priority) => (
    <LeadPriorityPresentation priority={priority}/>
  );

  const handleSelectionChange = (selectedValues) => {
    onSelectionChange && onSelectionChange(selectedValues);
  };

  if (readonly) {
    const priorityObject = LEAD_PRIORITY.find((p) => p.id === props.value);
    return <LeadPriorityPresentation priority={priorityObject} />
  }
  return (
    <LeadDropdownFilter
      placeholder={<F id={'pages.leads.filters.priority.placeholder'} defaultMessage={'Priority'}/>}
      optionRender={optionRender}
      filterKey={'priority'}
      options={LEAD_PRIORITY}
      onChange={handleSelectionChange}
      {...props}
      selectProps={{
        showSearch: false,
        style: {
          minWidth: 120
        },
        ...(props.selectProps || {})
      }}
    />
  );
};

export default LeadPriorityDropdownFilters;
